/* Bosque en Casa · un solo producto (Set Navidad, $599 MXN).
   Estados por URL para revisar: ?hoy=2026-11-28 (o cualquier fecha) · ?precio=699 · ?resenas=12 · ?video=1 (huecos de vídeo con chip)
   · ?carrito=1 (cajón con el set) · ?carrito=0 (vacío) · ?quieto=1 (todo terminado, como con «menos movimiento») */

/* En Shopify sale de la variable del producto ({{ product.price | money_without_trailing_zeros }}): nunca a mano */
const qs = new URLSearchParams(location.search);
const HERO = document.querySelector("[data-hero]");
const PRECIO = HERO ? Number(HERO.dataset.heroPrecio) : 0; // sale del producto de Shopify, nunca a mano
const AGOTADO = !!(HERO && HERO.dataset.agotado);
const BN = window.BN || {};
const CHECKOUT = HERO ? HERO.dataset.base + ":1" : "#"; // /cart/{variante}:1 → directo al checkout

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const precioTexto = (n) => "$" + n.toLocaleString("es-MX") + " MXN";
const quieto = qs.has("quieto") || matchMedia("(prefers-reduced-motion: reduce)").matches;
if (qs.has("quieto")) document.documentElement.classList.remove("js");

/* ── Fechas reales: 10 a 19 días naturales; Navidad hasta el miércoles 2 de diciembre ── */
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const CORTO = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const larga = (d) => `${d.getDate()} de ${MESES[d.getMonth()]}`;
function hoy() { return new Date(); }
function masDias(d, n) { const x = new Date(d); x.setDate(x.getDate() + n); return x; }
const dia = (y, m, d) => new Date(y, m - 1, d);

function pintarFechas() {
  const h = hoy();
  const d1 = masDias(h, BN.diasMin || 5), d2 = masDias(h, BN.diasMax || 11);
  const mismoMes = d1.getMonth() === d2.getMonth();
  const desde = mismoMes ? String(d1.getDate()) : larga(d1), hasta = larga(d2);
  const corta = (d) => `${d.getDate()}\u00a0${CORTO[d.getMonth()]}`;
  $$("[data-fecha]").forEach((el) => (el.textContent = `Si lo pides hoy, llega entre el ${desde} y el ${hasta}.`));
  $$("[data-fecha-corta]").forEach((el) => (el.textContent = `Llega entre el ${desde} y el ${hasta}.`));
  $$("[data-llega-corta]").forEach((el) => (el.textContent = `Llega entre el ${mismoMes ? d1.getDate() : corta(d1)} y el ${corta(d2)}`));

  // Una fecha por sitio: la fecha límite va en la barra roja (copy B.12, sin horas ni segundos)
  const fp = (BN.fin || "2026-12-02").split("-").map(Number);
  const fin = new Date(fp[0], fp[1] - 1, fp[2], 23, 59, 59);
  const aviso = masDias(fin, -6), tras = new Date(fp[0], fp[1] - 1, fp[2]), reyes = masDias(fin, 14);
  let barra = "Envío gratis a todo México";
  if (h < aviso) barra = BN.textoBarra || "Pídelo antes de la fecha límite y llega en Navidad";
  else if (h < tras) barra = `Quedan ${Math.ceil((fin - h) / 86400000)} días para pedir y recibir en Navidad`;
  else if (h <= fin) barra = "Hoy es el último día para pedir y recibir en Navidad";
  else if (h < reyes) barra = "Llega antes de Reyes si lo pides pronto";
  $$("[data-barra]").forEach((el) => (el.textContent = barra));

  // Pregunta 1 según la fecha
  if (h <= fin) return;
  const pq = $("[data-p1-pregunta]"), pr = $("[data-p1-respuesta]");
  if (!pq || !pr) return;
  if (h < reyes) {
    pq.textContent = "¿Llega antes de Navidad?";
    pr.textContent = "Si lo pides desde el 3 de diciembre, ya no te lo podemos prometer. Sí llega antes de Reyes si lo pides antes del 15.";
  } else {
    pq.textContent = "¿Cuándo llega?";
    pr.textContent = "Tarda de 5 a 11 días.";
  }
}

function pintarPrecio() {
  $$("[data-precio]").forEach((el) => (el.textContent = "$" + PRECIO.toLocaleString("es-MX")));
  $$("[data-precio-completo]").forEach((el) => (el.textContent = precioTexto(PRECIO)));
  if (!AGOTADO) $$("[data-comprar]").forEach((a) => (a.href = CHECKOUT));
  else $$("[data-comprar]").forEach((a) => a.addEventListener("click", (e) => e.preventDefault()));
}

/* ── Opiniones: ocultas mientras no haya ninguna real ── */
function pintarResenas() {
  const n = 0, el = $("[data-resenas]");
  if (!el || n < 1) return;
  el.hidden = false;
  $("[data-resenas-n]", el).textContent = `(${n})`;
  el.setAttribute("aria-label", `${n} ${n === 1 ? "opinión" : "opiniones"}`);
}

/* ── Historias del hero: se pasan tocando (izquierda / derecha), deslizando o con las flechas. Nunca solas.
   Solo imágenes reales: 1 = la mesa (póster y LCP; con data-video, el vídeo real), 2 = la lámina, 3 = el detalle. ── */
function iniciarHistorias() {
  const h = $("[data-historias]");
  if (!h) return;
  const pista = $(".historias__pista", h), slides = [...pista.children];
  const segs = $$(".historias__barras span", h), minis = $$("[data-historia-ir]");
  let actual = 0, visible = false;
  const alLlegar = [];
  const marcar = (i) => {
    actual = i;
    segs.forEach((sg, j) => { sg.classList.toggle("is-llena", j < i); sg.classList.toggle("is-actual", j === i); });
    minis.forEach((b, j) => b.classList.toggle("is-sel", j === i));
    if (visible) alLlegar.forEach((fn) => fn(i));
  };
  const ir = (i) => {
    i = Math.max(0, Math.min(slides.length - 1, i));
    pista.scrollTo({ left: i * pista.clientWidth, behavior: quieto ? "auto" : "smooth" });
    if (i !== actual) marcar(i);
  };
  pista.addEventListener("scroll", () => { const i = Math.round(pista.scrollLeft / pista.clientWidth); if (i !== actual) marcar(i); }, { passive: true });
  pista.addEventListener("click", (e) => {
    if (e.target.closest("button, a, video")) return;
    const r = pista.getBoundingClientRect();
    ir(e.clientX - r.left < r.width / 3 ? actual - 1 : actual + 1);
  });
  h.addEventListener("keydown", (e) => { if (e.key === "ArrowRight") ir(actual + 1); if (e.key === "ArrowLeft") ir(actual - 1); });
  minis.forEach((b) => b.addEventListener("click", () => ir(Number(b.dataset.historiaIr))));
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([e]) => {
      const antes = visible; visible = e.isIntersecting && e.intersectionRatio >= 0.5;
      if (visible && !antes) alLlegar.forEach((fn) => fn(actual));
    }, { threshold: [0, 0.5, 1] }).observe(h);
  } else visible = true;

  // Historia 1 con vídeo real: una vez al verse, con la foto de póster; al acabar se queda en el último fotograma
  const foto = slides[0], src = foto && foto.dataset.video;
  if (src && src !== "#") {
    const img = $("img", foto), otra1 = $("[data-otra-vez]", foto);
    const v = Object.assign(document.createElement("video"), { src, muted: true, playsInline: true, preload: "metadata", poster: img.currentSrc || img.src });
    v.className = "historia__video"; foto.insertBefore(v, img.nextSibling);
    let visto = false;
    alLlegar.push((i) => { if (i === 0 && !visto && !quieto) { visto = true; v.play().catch(() => {}); } });
    v.addEventListener("ended", () => (otra1.hidden = false));
    otra1.addEventListener("click", () => { otra1.hidden = true; v.currentTime = 0; v.play().catch(() => {}); });
  }
}

/* «Míralo armado» (hero, escritorio): baja a «Cómo se arma» y reproduce ahí el montaje (graficos/montaje).
   Si todavía no se ha visto, arranca solo al llegar; si ya se vio, se repite. */
function iniciarVerArmado() {
  const m = $("[data-montaje]");
  if (!m) return;
  $$("[data-ver-armado]").forEach((b) => b.addEventListener("click", () => {
    const yaVisto = m.dataset.estado === "anima";
    $(".montaje__placa", m).scrollIntoView({ behavior: quieto ? "auto" : "smooth", block: "center" });
    if (yaVisto && !quieto) setTimeout(() => { m.dataset.estado = "espera"; void m.offsetWidth; m.dataset.estado = "anima"; }, 600);
  }));
}

/* ── Huecos de vídeo: póster ligero; el vídeo solo se descarga al tocar ── */
function iniciarVideos() {
  $$("[data-video]").forEach((hueco) => {
    if (qs.has("video") && !hueco.dataset.video) hueco.dataset.video = "#";
    const boton = $("[data-play]", hueco);
    if (!boton) return;
    boton.addEventListener("click", () => {
      const src = hueco.dataset.video;
      if (!src || src === "#") return;
      const v = document.createElement("video");
      Object.assign(v, { src, controls: true, playsInline: true, autoplay: true });
      hueco.appendChild(v); boton.remove();
    });
  });
}

/* ── Escenas: arrancan cuando se ve más de la mitad y se reproducen una sola vez ── */
function alVerse(el, fn, margen = "0px") {
  if (quieto || !("IntersectionObserver" in window)) { el.classList.add("is-vista"); fn && fn(true); return; }
  const io = new IntersectionObserver((entradas) => entradas.forEach((e) => {
    const mitad = e.intersectionRatio >= 0.5 || e.intersectionRect.height >= innerHeight * 0.5;
    if (e.isIntersecting && mitad) { el.classList.add("is-vista"); io.disconnect(); fn && fn(false); }
  }), { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: margen });
  io.observe(el);
}

function iniciarEscenas() {
  $$("[data-vista], [data-escena]").forEach((el) => alVerse(el));
  $$("[data-entra]").forEach((el) => { if (!el.closest("[data-vista], .hero") ) alVerse(el); });
}

/* ── Preguntas: se abren con la curva de deslizar (220 ms) ── */
function iniciarPreguntas() {
  $$(".faq details").forEach((d) => {
    const s = $("summary", d), r = $(".respuesta", d);
    s.addEventListener("click", (ev) => {
      if (quieto || !r.animate) return;
      ev.preventDefault();
      const abrir = !d.open;
      if (abrir) d.open = true;
      const h = r.scrollHeight;
      const a = r.animate({ height: abrir ? ["0px", h + "px"] : [h + "px", "0px"], opacity: abrir ? [0, 1] : [1, 0] },
        { duration: 220, easing: "cubic-bezier(.32,.72,0,1)" });
      a.onfinish = () => { if (!abrir) d.open = false; };
    });
  });
}

/* ── Barra fija: visible solo cuando el botón del hero no se ve ── */
function iniciarBarra() {
  const barra = $("#barra"), boton = $("#comprar");
  if (!barra || !boton || !("IntersectionObserver" in window)) return;
  new IntersectionObserver(([e]) => barra.classList.toggle("is-visible", !e.isIntersecting)).observe(boton);
}

/* ── Menú en el móvil ── */
function iniciarMenu() {
  const b = $("[data-menu]"), m = $("#menu-movil");
  if (!b || !m) return;
  b.addEventListener("click", () => { const a = m.classList.toggle("is-abierto"); b.setAttribute("aria-expanded", a); });
  m.addEventListener("click", () => { m.classList.remove("is-abierto"); b.setAttribute("aria-expanded", "false"); });
}

function iniciarCarrito() {}

document.addEventListener("DOMContentLoaded", () => {
  pintarPrecio();
  pintarFechas();
  pintarResenas();
  iniciarHistorias();
  iniciarVerArmado();
  iniciarVideos();
  iniciarEscenas();
  iniciarPreguntas();
  iniciarBarra();
  iniciarMenu();
  iniciarCarrito();
});
